module.exports = __webpack_public_path__ + "static/media/profile-press-id.e80dcad3.png";